import React from 'react';
import TextField from '@material-ui/core/TextField';
import BasicLabel from '../BasicLabel/BasicLabel';
import './BasicTextArea.scss';
import AlphabetVarPopover from '../AlphabetVarPopover/AlphabetVarPopover';

export default class BasicTextArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            anchorEl: null,
            currentChar: 'A',
            value: props?.value
        }
    }
    onKeyUp = (event) => {
        if ((event.keyCode === 32 && event.ctrlKey == true) || event.keyCode === 115) {
            var char = 'A';
            var textValue = event?.target?.value;
            var textLen = textValue?.length;
            if (textLen > 0) {
                char = textValue[textLen - 1];
            }
            this.setState({
                isOpen: true,
                anchorEl: event.currentTarget,
                currentChar: char
            });
        }
        else if (this.props?.onKeyUp) {
            this.props?.onKeyUp(event);
        }
    }

    handlePopoverClose = () => {
        this.setState({ isOpen: false, anchorEl: null });
    }
    render() {
        let error = this.props?.value?.length > this.props.limit || (this.props.showMandatory && !this.props?.value) || false;
        let mandatoryWarning = "Please complete this mandatory field";
        return (
            <div className="BasicTextAreaContainer">
                {this.props?.label && <BasicLabel text={this.props?.label || ""} type={"text"}
                    isMandatory={this.props?.isMandatory || false} />}
                {this.props.showAsLabel ? <div className="showAsLabel">{this.props.value || ""} </div> :
                    <>
                        <TextField id={this.props?.id}
                            variant="outlined"
                            multiline
                            rows={this.props.rows || 3}
                            autoComplete='off'
                            value={this.props?.value || ""}
                            cols='50'
                            onChange={this.props?.onChange}
                            disabled={this.props?.disabled || false}
                            placeholder={this.props?.placeholder || ""}
                            className={this.props?.dividers ? "textAreaDividers" : ""}
                            onKeyUp={this.onKeyUp.bind(this)}
                            isAlphabetVar={true}
                            handleAlphabetVariantSelect={(value) =>
                                this.props?.onChange("address", value)
                            } 
                        />
                        {this.props?.isAlphabetVar && <AlphabetVarPopover isOpen={this.state.isOpen && this.props?.isAlphabetVar}
                            anchorEl={this.state.anchorEl}
                            handlePopoverClose={this.handlePopoverClose.bind(this)}
                            handleAlphabetVariantSelect={this.props?.handleAlphabetVariantSelect}
                            currentChar={this.state.currentChar}
                            value={this.props?.value}
                        />}
                    </>
                }
                {error && <div className="errorText">{((this.props.showMandatory && !this.props?.value) ? mandatoryWarning : this.props.limitWarning) || ""}</div>}
            </div>
        );
    }
}
